module.exports = __webpack_public_path__ + "img/workflow-section.0488bfd0.png";